<template>
  <div class="row">
    <div class="col-12">
      <ibox :title="'Użytkownicy'">
        <template slot="tools">
          <router-link
            to="/ustawienia/uzytkownicy/dodaj"
            class="btn btn-primary btn-xs"
          >
            Dodaj użytkownika
            <i class="fa fa-plus"></i>
          </router-link>
        </template>
        <template slot="content" slot-scope="{ setLoading }">
          <data-tables
            url="users/list"
            :columns_list="columns_list"
            @loading="setLoading"
          />
        </template>
      </ibox>
    </div>
  </div>
</template>

<script>
import Ibox from '@/components/Ibox'
import DataTables from '@/components/DataTables'
import { mapGetters } from 'vuex'

export default {
  name: 'UsersList',
  components: {
    Ibox,
    DataTables
  },
  data() {
    return {
      columns_list: [],
      roles_list: [],
      active_list: [
        { id: null, name: 'Wszystkie' },
        { id: 0, name: 'Nie' },
        { id: 1, name: 'Tak' }
      ]
    }
  },
  computed: {
    ...mapGetters( 'users', [ 'roles' ] )
  },
  created() {
    Promise.all( [ this.getTaskRoles() ] ).then( () => {
      this.columns_list = [
        {
          key: 'user_id',
          name: 'Szczegóły',
          filter: 'btn',
          btn: a =>
            `<a href="#/ustawienia/uzytkownicy/${a}"><i class="fa fa-edit"></i></a>`
        },
        {
          key: 'user_deleted_at',
          name: 'Data usunięcia',
          type: 'text',
          sortable: true
        },
        {
          key: 'user_name',
          name: 'Imię i nazwisko',
          type: 'text',
          sortable: true
        },
        {
          key: 'role_name',
          name: 'Rola',
          type: 'list',
          list: this.roles_list,
          sortable: true
        },
        {
          key: 'active',
          name: 'Aktywny',
          type: 'list',
          list: this.active_list,
          sortable: false,
          filter: 'btn',
          btn: a => { return ( a == 1) ? "Tak" : "Nie" }
        }
      ]
    } )
  },
  methods: {
    async getTaskRoles() {
      await this.$http.get( 'dictionary/roles' ).then( resp => {
        this.roles_list = [ ...[ { id: 0, name: this.$t( 'all' ) } ], ...resp.data ]
      } )
    }
  }
}
</script>
